<script lang="ts" setup>
// Ligne de notification mobile (markup gm-notif-row). Composant dédié car
// useTranslatedTimeAgo ne peut pas être appelé dans un v-for : chaque ligne calcule son
// propre horodatage relatif.
import useTranslatedTimeAgo from '~/composables/useTranslatedTimeAgo';
import type { UnreadNotification } from '~/interfaces/notifications/main';

const props = defineProps<{ notification: UnreadNotification }>();
const emit = defineEmits<{ read: [id: string | number] }>();

const when = useTranslatedTimeAgo(() => props.notification.createdAt);
</script>

<template>
  <div class="gm-notif-row">
    <span class="gm-notif-ic">
      <DsIcon
        name="bell"
        :size="14"
      />
    </span>
    <span class="gm-notif-body">
      <span class="gm-notif-title">{{ notification.title }}</span>
      <span class="gm-notif-text">{{ notification.content }}</span>
      <span class="gm-notif-when">{{ when }}</span>
    </span>
    <button
      class="gm-notif-read"
      title="Marquer comme lue"
      @click="emit('read', notification.id)"
    >
      <DsIcon
        name="check"
        :size="13"
      />
    </button>
  </div>
</template>
